/*import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';const hash = require('object-hash');
import FloatingVue from 'floating-vue'
Vue.use(FloatingVue);
window.Vue = Vue;
window.axios = require('axios');
Vue.use(VueSweetalert2);
Vue.prototype.base_url = baseUrl;
window.csrf_token = document.getElementById('csrf-token').value;
try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {
  console.log("Error when loading modules:",e);
}
Vue.mixin({
  computed: {
    cookies() {
      let obj = {};
      return document.cookie.split('; ').reduce((cookies, ck) => {
        let cookie = ck.split('=');
        cookies[cookie[0]] = cookie[1];
        return cookies;
      }, {});
    }
  }
});
axios.defaults.headers = {
  'X-CSRF-TOKEN': document.getElementById('csrf-token').value,
  'X-Requested-With': 'XMLHttpRequest'
}
Vue.prototype.$loading = function() {
  if (this.$refs['vue-block']) {
    this.$refs['vue-block'].style.display = 'initial';
  }
  this.loaded = true;
};
Vue.prototype.hash = function(data) {
  return hash(data);
};
Vue.prototype.read_notation = function(nbre) {
  return read_notation(nbre);
};
Vue.prototype.alt = function() {
  return alt(Array.from(arguments));
};
Vue.prototype.alt_0 = function(){
  return alt_0(arguments);
};
Vue.prototype.asset = function(url){
  return config.assetUrl + '/' + url;
};
Vue.prototype.route = function(url, params) {
  return route(url, params);
};
Vue.prototype.route_mmp = function(url) {
  return config.routeMmp(url);
};
Vue.prototype.format_date = function(date, format) {
  return moment(new Date(date)).format(format);
};
Vue.prototype.short_title = function(title, size=12) {
  if(title.length <= size){
    return title;
  }else{
    return title.slice(0,size-2)+"...";
  }
};
Vue.prototype.k_notation=function(number){
  let n = Number(number);
  return n.k_notation;
}
Vue.prototype.date_format = function(date,format) {
  return moment(date).format(format);
};
Vue.prototype.componentByString = function (str) {
  return {template:str};
}
Vue.prototype.route_skill = function(grade,skill) {
  return route('grade.skill.show',{grade:grade,skill:skill});
};
Vue.prototype.route_topic = function(topic) {
  return route('topic.show',{topic:topic});
};
Vue.prototype.route_grade = function(grade) {
  return route('grade.show',{grade:grade});
};
Vue.prototype.copy = function(arg){
  return JSON.parse(JSON.stringify(arg));
};
Vue.prototype.array_unique = function(array) {
  return array.distinct();
};
Vue.prototype.format_date = function(date, format) {
  return moment(new Date(date)).format(format);
};
const navLoginForm = new Vue({
  el: '#nav-login-form',
  data: {
    form: {
      userType: 'framer',
      username: '',
      password: '',
      login: 'login_form',
      _token: csrf_token,
    }
  },
  created() {
  },
  methods: {
    submit() {
      axios.post(route('login'), this.form).then(res => {
        let data = res.data,
        props = data.type == 'success' ? {
          timer: 4000,
          timerProgressBar: true,
          didOpen () {},
          willClose () {},
        } : {};
        this.$swal.fire({
          title: data.title,
          html: tag('div', (typeof data.message == 'object' ? [...Object.values(data.message)].join('<br>') : alt(data.message, 'You loged in successfully'))),
          icon: data.type,
          ...props
        }).then(result=>{
          if(data.type == 'success'){
            location.reload();
          }
        });
      })
    }
  }
});
$(function () {
  $('[data-toggle="tooltip"]').tooltip();
  $('[data-toggle="popover"]').popover();
$('.container-random').each(cr_index => {
  let positions = [], left, top, over = true;
  let cr = $(this);

})
let randoms = document.getElementsByClassName('container-random');
for (let cr of randoms) {
  let positions = [], left, top, over, cr_styles = window.getComputedStyle(cr), cr_props = {
    p_top: parseInt(cr_styles.getPropertyValue('padding-top').replace('px', '')),
    p_bottom: cr_styles.getPropertyValue('padding-bottom').replace('px', ''),
    p_left: cr_styles.getPropertyValue('padding-left').replace('px', ''),
    p_right: cr_styles.getPropertyValue('padding-right').replace('px', ''),
    width: cr.getBoundingClientRect().width,
    height: cr.getBoundingClientRect().height,
    min_top: cr.getBoundingClientRect().y,
    min_left: cr.getBoundingClientRect().x,
  }, items = cr.querySelectorAll('.random-item');
  // log('container random with index:', 'cr:', cr, 'cr_props:', cr_props, 'getBoundingClientRect:', cr.getBoundingClientRect());
  for (let item of items) {
    do {
      left = rn(0, (cr_props.width - item.offsetWidth - cr_props.min_left));
      top = rn(0, (cr_props.height - item.offsetHeight - cr_props.min_top));

      over = positions.reduce((a, b) => {
        return a || !(b.x[0] < left && left < b.x[1] && b.y[0] < top && top < b.y[1]);
      }, false);
    } while (over);

    positions.push({x: [left - 5, left + item.offsetWidth + 5], y: [top - 5, top + item.offsetHeight + 5]});

    item.style.top = top + 'px';
    item.style.left = left + 'px';

    // console.log('positioning random item on container:', 'props', 'max_top:', (cr_props.height - item.offsetHeight - cr_props.min_top), cr_props, 'min-width:', 0, 'max-left:', cr_props.width - item.offsetWidth, 'left:', left, 'top:', top, 'positions:', positions);
  }
}
})

*/

require('./base-script');

window._ = require('lodash');
Vue.component('pagination', require('laravel-vue-pagination'));